<template>
  <div>
    <h2 style="float: left;">
      Конференции и вебинары
    </h2>
    <publications
      type="seminars"
      detail-route-name="SeminarDetail"
      more-text="Узнать больше"
    />
  </div>
</template>

<script>
import Publications from '../components/Publications'

export default {
  name: 'Seminars',
  components: { Publications }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

h2 {
  float: left;
}
</style>
